import "core-js/modules/es.string.link.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-button-group", [_vm.title ? _c("el-button", {
    attrs: {
      size: "mini"
    },
    on: {
      click: function click($event) {
        return _vm.$open(_vm.link);
      }
    }
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c("el-button", {
    attrs: {
      size: "mini"
    },
    on: {
      click: function click($event) {
        return _vm.$open(_vm.link);
      }
    }
  }, [_c("d2-icon", {
    attrs: {
      name: _vm.icon
    }
  }), _vm._v(" " + _vm._s(_vm.link) + " ")], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };